<!-- Profile Header with integrated navigation -->
<div class="bg-white border-b border-gray-200">
  <div class="mx-auto px-4 max-w-5xl">
    <!-- Top Section: Title -->
    <div class="flex items-center justify-between py-6">
      <div class="flex items-center gap-4">
        <div class="w-12 h-12 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-lg shadow-blue-500/20">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
          </svg>
        </div>
        <div>
          <h1 class="text-2xl font-bold text-gray-900">Profile & Settings</h1>
          <p class="text-sm text-gray-500">Manage your personal information and preferences</p>
        </div>
      </div>
    </div>

    <!-- Navigation Tabs -->
    <div class="flex items-center gap-1 -mb-px">
      @for(item of navItems(); track item.id) {
        <button
          (click)="onTabChange(item.id)"
          class="relative px-4 py-3 text-sm font-medium transition-all duration-200 flex items-center gap-2 rounded-t-lg cursor-pointer"
          [class.text-blue-600]="activeTab() === item.id"
          [class.text-gray-500]="activeTab() !== item.id"
          [class.hover:text-gray-700]="activeTab() !== item.id"
          [class.hover:bg-gray-50]="activeTab() !== item.id">

          <!-- Icon -->
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="item.icon"/>
          </svg>

          <!-- Label -->
          <span>{{ item.label }}</span>

          <!-- Active indicator -->
          @if(activeTab() === item.id) {
            <span class="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600 rounded-full"></span>
          }
        </button>
      }
    </div>
  </div>
</div>

<!-- Content Area -->
<div class="bg-gray-50 min-h-[calc(100vh-180px)]">
  <div class="mx-auto px-4 max-w-5xl py-6">
    <router-outlet />
  </div>
</div>
